import { render } from "./BottomButtons.vue?vue&type=template&id=06e4e484"
import script from "./BottomButtons.vue?vue&type=script&lang=js"
export * from "./BottomButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\reimo\\Documents\\Projektide IT osa\\AccountaBuddy\\accounta-buddy-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__